import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustSignals from "@/components/TrustSignals";
import Services from "@/components/Services";
import LatestNews from "@/components/LatestNews";
import CallToAction from "@/components/CallToAction";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <>
      <Helmet>
        <title>AI-labbet | We create value with responsible AI</title>
        <meta name="description" content="AI-labbet provides AI strategy, governance, and skilling services. We help organizations create business value through responsible AI." />
      </Helmet>
      
      <div className="min-h-screen bg-background">
        <Header />
        <main>
          <Hero />
          
          <Services />
          <LatestNews />
          <CallToAction />
        </main>
        <Footer />
      </div>
    </>
  );
};
export default Index;